import { Button, MenuItem, Select, Typography } from '@mui/material';
import { Table } from '@tanstack/react-table';
import { L } from 'harmony-language';
import React from 'react';
import { Load } from '../../../../types';
import { ReactTableColumns } from '../../../reports/report-types';

interface AgisticsTablePagingProps<T> {
    table: Table<T>;
    setPageSizePreferences?: (p: number) => void;
}

export const AgisticsTablePaging = <T extends ReactTableColumns | Load>(props: React.PropsWithChildren<AgisticsTablePagingProps<T>>) => {
    const { table, setPageSizePreferences, children } = props;

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '1rem' }}>
            <span>
                {L.totalRecords(table.getRowCount().toString())}&nbsp;-&nbsp;
                {L.displayedRecords(table.getRowModel().rows.length.toString())}
                {children}
            </span>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <Typography style={{ marginRight: '10px' }}>{L.rowsPerPage()}</Typography>
                <Select
                    variant='standard'
                    disableUnderline
                    defaultValue={50}
                    value={table.getState().pagination.pageSize}
                    onChange={e => {
                        const pageSize = Number(e.target.value);
                        table.setPageSize(pageSize);
                        setPageSizePreferences && setPageSizePreferences(pageSize);
                    }}>
                    {[5, 10, 25, 50, 100].map(pageSize => (
                        <MenuItem key={pageSize} value={pageSize}>{pageSize}</MenuItem>
                    ))}
                </Select>
                <span className='' style={{ marginLeft: '10px', marginRight: '10px' }}>
                    <span>{L.page()} {' '}</span>
                    <strong>
                        {table.getState().pagination.pageIndex + 1} of{' '}
                        {table.getPageCount().toLocaleString()}
                    </strong>
                </span>
                <Button
                    size='small'
                    variant='outlined'
                    onClick={() => table.firstPage()}
                    disabled={!table.getCanPreviousPage()}
                >
                    {'<<'}
                </Button>
                <Button
                    size='small'
                    variant='outlined'
                    onClick={() => table.previousPage()}
                    disabled={!table.getCanPreviousPage()}
                >
                    {'<'}
                </Button>
                <Button
                    size='small'
                    variant='outlined'
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                >
                    {'>'}
                </Button>
                <Button
                    size='small'
                    variant='outlined'
                    onClick={() => table.lastPage()}
                    disabled={!table.getCanNextPage()}
                >
                    {'>>'}
                </Button>
                {/* works, but not sure we need?
                <span className=''>
                    | Go to page:
                        <input
                            type='number'
                            defaultValue={table.getState().pagination.pageIndex + 1}
                            onChange={e => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                            table.setPageIndex(page)
                            }}
                            className=''
                        />
                </span> */}
            </span>
        </div>
    );
};
